import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import ProjectsPage from './pages/ProjectsPage';
import NotFoundPage from './pages/NotFoundPage';
import ServicePage from './pages/ServicePage';
import { AUTOMATION_PATH, HOME_PATH, PROJECTS_PATH, WEBSITES_PATH } from './routes';

// How long a #hash target is held in place while the sections above it are
// still loading their projects and pushing it down.
const HASH_SETTLE_MS = 3000;
const USER_SCROLL = ['wheel', 'touchstart', 'keydown', 'mousedown'];

// The router neither scrolls to a #hash nor back to the top when the page
// changes, so a link from /projekty/ to /#contact would land mid-page.
function ScrollManager() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, behavior: 'instant' });
            return undefined;
        }

        const align = () => {
            const el = document.getElementById(hash.slice(1));
            if (el) el.scrollIntoView({ block: 'start', behavior: 'instant' });
        };
        align();

        // Re-align on every layout change until things settle or the visitor
        // scrolls on their own.
        const observer = new ResizeObserver(align);
        observer.observe(document.body);
        const stop = () => {
            observer.disconnect();
            clearTimeout(timer);
            USER_SCROLL.forEach(type => window.removeEventListener(type, stop));
        };
        const timer = setTimeout(stop, HASH_SETTLE_MS);
        USER_SCROLL.forEach(type => window.addEventListener(type, stop, { passive: true }));
        return stop;
    }, [pathname, hash]);

    return null;
}

function App() {
    // PUBLIC_URL is '/en' for the English build, so every route still
    // matches when the site is served from a subdirectory.
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <ScrollManager />
            <Routes>
                <Route path={HOME_PATH} element={<LandingPage />} />
                <Route path={PROJECTS_PATH} element={<ProjectsPage />} />
                <Route path={WEBSITES_PATH} element={<ServicePage key="websites" service="websites" />} />
                <Route path={AUTOMATION_PATH} element={<ServicePage key="automation" service="automation" />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
}

export default App;
